import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubProductService {

  constructor(private httpClientService:HttpClientService) { }
  async removeSubProduct(id){
    const observable:Observable<any> = this.httpClientService.delete({
      controller:ControllerType.SubProduct
    },id);
    return await firstValueFrom(observable);
  }

  async createSubProduct(productId,connectedSubProduct,count){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.SubProduct
    },{
      connectedProductId : productId,
      connectedSubProductId:connectedSubProduct,
      productCount:count
    });
    return await firstValueFrom(observable);
  }

  async updateSubProduct(id,connectedSubProductId,count){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.SubProduct
    },{
      id : id,
      connectedSubProductId:connectedSubProductId,
      productCount:count
    });
    return await firstValueFrom(observable);
  }

}
